import { ApplicationConfig, InjectionToken, inject, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideNzI18n, en_US } from 'ng-zorro-antd/i18n';
import { provideAppInitializer } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { routes } from './app.routes';
import { provideNzIcons } from './icons-provider';
import { httpInterceptor } from '@core/interceptors/http.interceptor';
import { environment } from '@environments/environment';
import { ConfigService } from '@core/services/config.service';

export const API_URL = new InjectionToken<string>('API_URL');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    provideAnimations(),
    provideNzIcons(),
    provideEnvironmentNgxMask(),
    provideNzI18n(en_US),
    importProvidersFrom(NzModalModule),

    { provide: API_URL, useValue: environment.apiUrl },

    // Modern app initializer using Angular 19 approach
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      try {
        configService.loadConfig().subscribe();
      } catch {
        // Config initialization failed
      }
    }),
  ],
};
